
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

require("jquery")(window)
Vue.component('icon', Icon);
Vue.use(VueAxios, axios);

import Vuetify from 'vuetify'

Vue.use(Vuetify);

// index.js or main.js
import 'vuetify/dist/vuetify.min.css';
//import 'bootstrap-rtl/dist/css/bootstrap-rtl.css'
import '@/assets/css/my-style.css'

let originalVueComponent = Vue.component;
Vue.component = function(name, definition) {
    if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' ||
        name === 'bCheckGroup' || name === 'bFormRadioGroup') {
        definition.components = {bFormCheckbox: definition.components[0]}
    }
    originalVueComponent.apply(this, [name, definition])
};
Vue.component = originalVueComponent;

Vue.config.productionTip = false;

//console.log(process.env.NODE_ENV);

window.ApibaseUrl=
    process.env.NODE_ENV === "development" ?'http://192.168.1.101:8000/' : 'http://online-hearing-test-server.persia-tone.com/';

// import sounds

import tone500 from '@/assets/sounds/pure_tone/500.mp3';
import tone1000 from '@/assets/sounds/pure_tone/1000.mp3';
import tone2000 from '@/assets/sounds/pure_tone/2000.mp3';
import tone4000 from '@/assets/sounds/pure_tone/4000.mp3';
window.pure_tone = [];
window.pure_tone['tone500'] = tone500;
window.pure_tone['tone1000'] =  tone1000;
window.pure_tone['tone2000'] =  tone2000;
window.pure_tone['tone4000'] =  tone4000;

import tone500L from '@/assets/sounds/pure_tone/500L.mp3';
import tone500R from '@/assets/sounds/pure_tone/500R.mp3';

import tone1000L from '@/assets/sounds/pure_tone/1000L.mp3';
import tone1000R from '@/assets/sounds/pure_tone/1000R.mp3';

import tone2000L from '@/assets/sounds/pure_tone/2000L.mp3';
import tone2000R from '@/assets/sounds/pure_tone/2000R.mp3';

import tone4000L from '@/assets/sounds/pure_tone/4000L.mp3';
import tone4000R from '@/assets/sounds/pure_tone/4000R.mp3';

window.pure_tone_lr = [];
window.pure_tone_lr['tone500L'] = tone500L;
window.pure_tone_lr['tone500R'] =  tone500R;
window.pure_tone_lr['tone1000L'] =  tone1000L;
window.pure_tone_lr['tone1000R'] =  tone1000R;
window.pure_tone_lr['tone2000L'] =  tone2000L;
window.pure_tone_lr['tone2000R'] =  tone2000R;
window.pure_tone_lr['tone4000L'] =  tone4000L;
window.pure_tone_lr['tone4000R'] =  tone4000R;

window.questionsAnswer = null
window.calibrationAnswers = null
window.PureToneAnswers = null
window.SpeechTestAnswers= null

window.token = null;



new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
    created: function () {

        let self = this;
        self.axios.get(ApibaseUrl+"api/v1/init").then((response) => {
            self.initData = response.data.result;
            //window.token = response.data.result.token;
            self.axios.defaults.headers.common = {
                'X-CSRF-TOKEN': response.data.result.token,
                'X-Requested-With': 'XMLHttpRequest'
            };
            document.title = self.initData.site_name;
        })

    },
    data: {
        initData: [],
    },

});





// WEBPACK FOOTER //
// ./src/main.js